<template lang="pug">
  .notification
    .columns
      .column.is-half
        strong Fin Carga:&nbsp
        | {{ carga.finCarga }}
        br
        strong Volumen (20°C):&nbsp
        | {{ carga.volumen20 }}
        br
        strong Masa:&nbsp
        | {{ parseInt(carga.masaKgs) }}
        br
        strong Presión:&nbsp
        | {{ carga.presion }}
        br
        strong Densidad (20°C):&nbsp
        | {{ carga.densidad20 }}
        br
        strong Densidad (20°C) CORREGIDA:&nbsp
        | {{ carga.densidad20Corregida }}
        br
        strong LLenadera:&nbsp
        | {{ carga.llenadera }}
        br
      .column.is-half
        strong Contenido en Litros:&nbsp
        | {{ Math.round(contenidoLitros) }}
        br
        strong Litros en Carta Porte:&nbsp
        | {{ Math.round(carga.litrosCP) }}
        br
        strong Peso:&nbsp
        | {{acceso.pesoEntrada}}
        br
        strong Sellos:&nbsp
        |<span v-for="item in acceso.sellos" v-text="item.sello" class="tag is-light"></span>
        br
        strong Magnatel:&nbsp
        | {{acceso.magnatel}}
        br
        strong Presion:&nbsp
        | {{acceso.presion}}
        br
        strong ID Nominacion:&nbsp
        |{{empresa.id !== 2 ? acceso.program_id  : acceso.programa_nomcar_id}}
        br

</template>

<script>
  export default {
    name: 'CardDatosCC',
    props: {
      carga: {
        type: Object,
        default: {}
      },
      valorUnitario: {
        type: Number,
        default: 0
      },
      acceso:{
        type: Object,
        default: {}
      },
      empresa:{
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        contenidoLitros: 0,
        cargaTotal: 0
      }
    },
    watch: {
      carga() {
        this.getCargaTotal()
      }
    },
    methods: {
      getCargaTotal() {
        this.contenidoLitros = parseFloat(42 * 3.785412 * parseFloat(this.carga.volumen20))
        this.cargaTotal = parseFloat(this.valorUnitario * this.contenidoLitros).toFixed(2)
        this.$emit('cargaTotal', this.cargaTotal)
        this.$emit('contenidoLitros', this.contenidoLitros)
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/sca_Componentes/componentes/CardDatosCC.vue